module.exports = __webpack_public_path__ + "media/images/dragDrop__infoIcon@3x-d089bb7560d1123975ad755f1b5c49ab.png";